import { Field } from './field';
import { cr } from 'fire-wind-water';

class CustomPolicy extends Field {
  isSelected: boolean;
  privacyPolicyTitle: any;
  listOptionMap: any;

  constructor(field: unknown) {
    super(field);
    const attr = ['privacyPolicyTitle', 'isSelected', 'value'];
    cr.each(attr, (d) => {
      this[d] = field[d];
    });
    this.listOptionMap = {
      true: '同意',
      false: '不同意'
    };
    this.isSelected = this.fieldInfo.isSelected == 1;
    this.value = this.listOptionMap[`${this.isSelected}`];
    this.isError();
  }

  setValue(val: any): void {
    this.isSelected = val;
    this.value = this.listOptionMap[`${this.isSelected}`];
    this.dirty = true;
    this.isError();
  }

  initValue(val: any): void {
    this.setValue(val);
    this.dirty = false;
  }

  clearValue(): void {
    this.isSelected = this.fieldInfo.isSelected == 1;
    this.value = this.listOptionMap[`${this.isSelected}`];
    this.dirty = false;
    this.isError();
  }

  protected isError(): void {
    this.setError();
    this.hasError();
  }
}

export { CustomPolicy };
